// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2m4mp","col":"styles_col__2hJFF"};